import { MODULES } from './modules'
import { CLIENTS } from './clients'

export const ACCESS_CONFIG = {
  application: {
    types: ['loyalty, generic'],
    modules: MODULES as unknown as Array<{
      name: string
      subs: { name: string; subs?: { name: string }[] }[]
      access: { status: { status: string; subs: { name: string }[] }[] }
    }>,
    clients: CLIENTS,
  },
}
